/**
 * Binance Sub Account REST API
 *
 * OpenAPI Specification for the Binance Sub Account REST API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ConfigurationRestAPI,
    TimeUnit,
    RestApiResponse,
    assertParamExists,
    sendRequest,
    type RequestArgs,
} from '@binance/common';
import type {
    FuturesTransferForSubAccountResponse,
    GetDetailOnSubAccountsFuturesAccountResponse,
    GetDetailOnSubAccountsFuturesAccountV2Response,
    GetDetailOnSubAccountsMarginAccountResponse,
    GetMovePositionHistoryForSubAccountResponse,
    GetSubAccountDepositAddressResponse,
    GetSubAccountDepositHistoryResponse,
    GetSummaryOfSubAccountsFuturesAccountResponse,
    GetSummaryOfSubAccountsFuturesAccountV2Response,
    GetSummaryOfSubAccountsMarginAccountResponse,
    MarginTransferForSubAccountResponse,
    MovePositionForSubAccountOrderArgsParameterInner,
    MovePositionForSubAccountResponse,
    QuerySubAccountAssetsAssetManagementResponse,
    QuerySubAccountAssetsResponse,
    QuerySubAccountFuturesAssetTransferHistoryResponse,
    QuerySubAccountSpotAssetTransferHistoryResponse,
    QuerySubAccountSpotAssetsSummaryResponse,
    QueryUniversalTransferHistoryResponse,
    SubAccountFuturesAssetTransferResponse,
    SubAccountTransferHistoryResponse,
    TransferToMasterResponse,
    TransferToSubAccountOfSameMasterResponse,
    UniversalTransferResponse,
} from '../types';

/**
 * AssetManagementApi - axios parameter creator
 */
const AssetManagementApiAxiosParamCreator = function (configuration: ConfigurationRestAPI) {
    return {
        /**
         * Futures Transfer for Sub-account
         *
         * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
         *
         * Weight: 1
         *
         * @summary Futures Transfer for Sub-account (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {string} asset
         * @param {number} amount
         * @param {number | bigint} type 1: transfer from subaccount's  spot account to margin account 2: transfer from subaccount's margin account to its spot account
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        futuresTransferForSubAccount: async (
            email: string,
            asset: string,
            amount: number,
            type: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('futuresTransferForSubAccount', 'email', email);
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('futuresTransferForSubAccount', 'asset', asset);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('futuresTransferForSubAccount', 'amount', amount);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('futuresTransferForSubAccount', 'type', type);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (amount !== undefined && amount !== null) {
                localVarQueryParameter['amount'] = amount;
            }
            if (type !== undefined && type !== null) {
                localVarQueryParameter['type'] = type;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/futures/transfer',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Get Detail on Sub-account's Futures Account
         *
         * Weight: 10
         *
         * @summary Get Detail on Sub-account\'s Futures Account (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getDetailOnSubAccountsFuturesAccount: async (
            email: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getDetailOnSubAccountsFuturesAccount', 'email', email);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/futures/account',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Get Detail on Sub-account's Futures Account
         *
         * Weight: 1
         *
         * @summary Get Detail on Sub-account\'s Futures Account V2 (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {number | bigint} futuresType 1:USDT-margined Futures，2: Coin-margined Futures
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getDetailOnSubAccountsFuturesAccountV2: async (
            email: string,
            futuresType: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getDetailOnSubAccountsFuturesAccountV2', 'email', email);
            // verify required parameter 'futuresType' is not null or undefined
            assertParamExists('getDetailOnSubAccountsFuturesAccountV2', 'futuresType', futuresType);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (futuresType !== undefined && futuresType !== null) {
                localVarQueryParameter['futuresType'] = futuresType;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v2/sub-account/futures/account',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Get Detail on Sub-account's Margin Account
         *
         * Weight: 10
         *
         * @summary Get Detail on Sub-account\'s Margin Account (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getDetailOnSubAccountsMarginAccount: async (
            email: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getDetailOnSubAccountsMarginAccount', 'email', email);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/margin/account',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Query move position history
         *
         * If `startTime` and `endTime` not sent, return records of the last 90 days by default with 1000 maximum limits
         * If `startTime` is sent and `endTime` is not sent, return records of [max(startTime, now-90d), now].
         * If `startTime` is not sent and `endTime` is sent, return records of [max(now,endTime-90d), endTime].
         *
         * Weight: 1
         *
         * @summary Get Move Position History for Sub-account (For Master Account) (USER_DATA)
         * @param {string} symbol
         * @param {number | bigint} page Page
         * @param {number | bigint} row
         * @param {number | bigint} [startTime]
         * @param {number | bigint} [endTime]
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getMovePositionHistoryForSubAccount: async (
            symbol: string,
            page: number | bigint,
            row: number | bigint,
            startTime?: number | bigint,
            endTime?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'symbol' is not null or undefined
            assertParamExists('getMovePositionHistoryForSubAccount', 'symbol', symbol);
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getMovePositionHistoryForSubAccount', 'page', page);
            // verify required parameter 'row' is not null or undefined
            assertParamExists('getMovePositionHistoryForSubAccount', 'row', row);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (symbol !== undefined && symbol !== null) {
                localVarQueryParameter['symbol'] = symbol;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }
            if (row !== undefined && row !== null) {
                localVarQueryParameter['row'] = row;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/futures/move-position',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Fetch sub-account deposit address
         *
         * `amount` needs to be sent if using LIGHTNING network
         *
         * Weight: 1
         *
         * @summary Get Sub-account Deposit Address (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {string} coin
         * @param {string} [network] networks can be found in `GET /sapi/v1/capital/deposit/address`
         * @param {number} [amount]
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getSubAccountDepositAddress: async (
            email: string,
            coin: string,
            network?: string,
            amount?: number,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getSubAccountDepositAddress', 'email', email);
            // verify required parameter 'coin' is not null or undefined
            assertParamExists('getSubAccountDepositAddress', 'coin', coin);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (coin !== undefined && coin !== null) {
                localVarQueryParameter['coin'] = coin;
            }
            if (network !== undefined && network !== null) {
                localVarQueryParameter['network'] = network;
            }
            if (amount !== undefined && amount !== null) {
                localVarQueryParameter['amount'] = amount;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/capital/deposit/subAddress',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Fetch sub-account deposit history
         *
         * Weight: 1
         *
         * @summary Get Sub-account Deposit History (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {string} [coin]
         * @param {number | bigint} [status] 0(0:pending,6: credited but cannot withdraw,7:Wrong Deposit,8:Waiting User confirm,1:success)
         * @param {number | bigint} [startTime]
         * @param {number | bigint} [endTime]
         * @param {number | bigint} [limit] Default value: 1, Max value: 200
         * @param {number | bigint} [offset] default:0
         * @param {number | bigint} [recvWindow]
         * @param {string} [txId]
         *
         * @throws {RequiredError}
         */
        getSubAccountDepositHistory: async (
            email: string,
            coin?: string,
            status?: number | bigint,
            startTime?: number | bigint,
            endTime?: number | bigint,
            limit?: number | bigint,
            offset?: number | bigint,
            recvWindow?: number | bigint,
            txId?: string
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getSubAccountDepositHistory', 'email', email);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (coin !== undefined && coin !== null) {
                localVarQueryParameter['coin'] = coin;
            }
            if (status !== undefined && status !== null) {
                localVarQueryParameter['status'] = status;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (limit !== undefined && limit !== null) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined && offset !== null) {
                localVarQueryParameter['offset'] = offset;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }
            if (txId !== undefined && txId !== null) {
                localVarQueryParameter['txId'] = txId;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/capital/deposit/subHisrec',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Get Summary of Sub-account's Futures Account
         *
         * Weight: 1
         *
         * @summary Get Summary of Sub-account\'s Futures Account (For Master Account) (USER_DATA)
         * @param {number | bigint} page Page
         * @param {number | bigint} limit Limit (Max: 500)
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getSummaryOfSubAccountsFuturesAccount: async (
            page: number | bigint,
            limit: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getSummaryOfSubAccountsFuturesAccount', 'page', page);
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getSummaryOfSubAccountsFuturesAccount', 'limit', limit);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined && limit !== null) {
                localVarQueryParameter['limit'] = limit;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/futures/accountSummary',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Get Summary of Sub-account's Futures Account
         *
         * Weight: 10
         *
         * @summary Get Summary of Sub-account\'s Futures Account V2 (For Master Account) (USER_DATA)
         * @param {number | bigint} futuresType 1:USDT-margined Futures，2: Coin-margined Futures
         * @param {number | bigint} [page] Default value: 1
         * @param {number | bigint} [limit] Default value: 1, Max value: 200
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getSummaryOfSubAccountsFuturesAccountV2: async (
            futuresType: number | bigint,
            page?: number | bigint,
            limit?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'futuresType' is not null or undefined
            assertParamExists(
                'getSummaryOfSubAccountsFuturesAccountV2',
                'futuresType',
                futuresType
            );

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (futuresType !== undefined && futuresType !== null) {
                localVarQueryParameter['futuresType'] = futuresType;
            }
            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined && limit !== null) {
                localVarQueryParameter['limit'] = limit;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v2/sub-account/futures/accountSummary',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Get Summary of Sub-account's Margin Account
         *
         * Weight: 10
         *
         * @summary Get Summary of Sub-account\'s Margin Account (For Master Account) (USER_DATA)
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        getSummaryOfSubAccountsMarginAccount: async (
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/margin/accountSummary',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Margin Transfer for Sub-account
         *
         * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
         *
         * Weight: 1
         *
         * @summary Margin Transfer for Sub-account (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {string} asset
         * @param {number} amount
         * @param {number | bigint} type 1: transfer from subaccount's  spot account to margin account 2: transfer from subaccount's margin account to its spot account
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        marginTransferForSubAccount: async (
            email: string,
            asset: string,
            amount: number,
            type: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('marginTransferForSubAccount', 'email', email);
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('marginTransferForSubAccount', 'asset', asset);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('marginTransferForSubAccount', 'amount', amount);
            // verify required parameter 'type' is not null or undefined
            assertParamExists('marginTransferForSubAccount', 'type', type);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (amount !== undefined && amount !== null) {
                localVarQueryParameter['amount'] = amount;
            }
            if (type !== undefined && type !== null) {
                localVarQueryParameter['type'] = type;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/margin/transfer',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Move position between sub-master, master-sub, or sub-sub accounts when necessary
         *
         * You need to Enable Trading permission for the API Key which requests this endpoint.
         * This function only support VIP level 7-9.
         * Only master account can use the function
         * Quantity should be positive number only
         * The function support normal account, PM PRO, PM PRO SPAN and PM Retail.
         * Only support for from account has positions
         * For all orders in the same orderArgs request, if any symbol’s total close position quantity is bigger than the symbol’s current position quantity, all batch orders in the same list will fail simultaneously.
         * Only support cross margin mode
         * The price for move position is MarkPrice only.
         * Not support for MSA.
         * Not support for the symbol under Reduce-Only.
         *
         * Weight: 1
         *
         * @summary Move Position for Sub-account (For Master Account) (USER_DATA)
         * @param {string} fromUserEmail
         * @param {string} toUserEmail
         * @param {string} productType Only support UM
         * @param {Array<MovePositionForSubAccountOrderArgsParameterInner>} orderArgs Max 10 positions supported. When input request parameter,orderArgs.symbol should be STRING, orderArgs.quantity should be BIGDECIMAL, and orderArgs.positionSide should be STRING, positionSide support BOTH,LONG and SHORT. Each entry should be like orderArgs[0].symbol=BTCUSDT,orderArgs[0].quantity=0.001,orderArgs[0].positionSide=BOTH. Example of the request parameter array: orderArgs[0].symbol=BTCUSDT orderArgs[0].quantity=0.001 orderArgs[0].positionSide=BOTH orderArgs[1].symbol=ETHUSDT orderArgs[1].quantity=0.01 orderArgs[1].positionSide=BOTH
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        movePositionForSubAccount: async (
            fromUserEmail: string,
            toUserEmail: string,
            productType: string,
            orderArgs: Array<MovePositionForSubAccountOrderArgsParameterInner>,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'fromUserEmail' is not null or undefined
            assertParamExists('movePositionForSubAccount', 'fromUserEmail', fromUserEmail);
            // verify required parameter 'toUserEmail' is not null or undefined
            assertParamExists('movePositionForSubAccount', 'toUserEmail', toUserEmail);
            // verify required parameter 'productType' is not null or undefined
            assertParamExists('movePositionForSubAccount', 'productType', productType);
            // verify required parameter 'orderArgs' is not null or undefined
            assertParamExists('movePositionForSubAccount', 'orderArgs', orderArgs);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (fromUserEmail !== undefined && fromUserEmail !== null) {
                localVarQueryParameter['fromUserEmail'] = fromUserEmail;
            }
            if (toUserEmail !== undefined && toUserEmail !== null) {
                localVarQueryParameter['toUserEmail'] = toUserEmail;
            }
            if (productType !== undefined && productType !== null) {
                localVarQueryParameter['productType'] = productType;
            }
            if (orderArgs) {
                localVarQueryParameter['orderArgs'] = orderArgs;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/futures/move-position',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Fetch sub-account assets
         *
         * Weight: 60
         *
         * @summary Query Sub-account Assets (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        querySubAccountAssets: async (
            email: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('querySubAccountAssets', 'email', email);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v3/sub-account/assets',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Fetch sub-account assets
         *
         * Weight: 60
         *
         * @summary Query Sub-account Assets (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        querySubAccountAssetsAssetManagement: async (
            email: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('querySubAccountAssetsAssetManagement', 'email', email);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v4/sub-account/assets',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Query Sub-account Futures Asset Transfer History
         *
         * Weight: 1
         *
         * @summary Query Sub-account Futures Asset Transfer History (For Master Account) (USER_DATA)
         * @param {string} email [Sub-account email](#email-address)
         * @param {number | bigint} futuresType 1:USDT-margined Futures，2: Coin-margined Futures
         * @param {number | bigint} [startTime]
         * @param {number | bigint} [endTime]
         * @param {number | bigint} [page] Default value: 1
         * @param {number | bigint} [limit] Default value: 1, Max value: 200
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        querySubAccountFuturesAssetTransferHistory: async (
            email: string,
            futuresType: number | bigint,
            startTime?: number | bigint,
            endTime?: number | bigint,
            page?: number | bigint,
            limit?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('querySubAccountFuturesAssetTransferHistory', 'email', email);
            // verify required parameter 'futuresType' is not null or undefined
            assertParamExists(
                'querySubAccountFuturesAssetTransferHistory',
                'futuresType',
                futuresType
            );

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (futuresType !== undefined && futuresType !== null) {
                localVarQueryParameter['futuresType'] = futuresType;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined && limit !== null) {
                localVarQueryParameter['limit'] = limit;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/futures/internalTransfer',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Query Sub-account Spot Asset Transfer History
         *
         * fromEmail and toEmail cannot be sent at the same time.
         * Return fromEmail equal master account email by default.
         *
         * Weight: 1
         *
         * @summary Query Sub-account Spot Asset Transfer History (For Master Account) (USER_DATA)
         * @param {string} [fromEmail]
         * @param {string} [toEmail]
         * @param {number | bigint} [startTime]
         * @param {number | bigint} [endTime]
         * @param {number | bigint} [page] Default value: 1
         * @param {number | bigint} [limit] Default value: 1, Max value: 200
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        querySubAccountSpotAssetTransferHistory: async (
            fromEmail?: string,
            toEmail?: string,
            startTime?: number | bigint,
            endTime?: number | bigint,
            page?: number | bigint,
            limit?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (fromEmail !== undefined && fromEmail !== null) {
                localVarQueryParameter['fromEmail'] = fromEmail;
            }
            if (toEmail !== undefined && toEmail !== null) {
                localVarQueryParameter['toEmail'] = toEmail;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined && limit !== null) {
                localVarQueryParameter['limit'] = limit;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/sub/transfer/history',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Get BTC valued asset summary of subaccounts.
         *
         * Weight: 1
         *
         * @summary Query Sub-account Spot Assets Summary (For Master Account) (USER_DATA)
         * @param {string} [email] Managed sub-account email
         * @param {number | bigint} [page] Default value: 1
         * @param {number | bigint} [size] default 10, max 20
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        querySubAccountSpotAssetsSummary: async (
            email?: string,
            page?: number | bigint,
            size?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (email !== undefined && email !== null) {
                localVarQueryParameter['email'] = email;
            }
            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined && size !== null) {
                localVarQueryParameter['size'] = size;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/spotSummary',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Query Universal Transfer History
         *
         * fromEmail and toEmail cannot be sent at the same time.
         * Return fromEmail equal master account email by default.
         * The query time period must be less than 7 days.
         * If startTime and endTime not sent, return records of the last 7 days by default.
         *
         * Weight: 1
         *
         * @summary Query Universal Transfer History (For Master Account) (USER_DATA)
         * @param {string} [fromEmail]
         * @param {string} [toEmail]
         * @param {string} [clientTranId]
         * @param {number | bigint} [startTime]
         * @param {number | bigint} [endTime]
         * @param {number | bigint} [page] Default value: 1
         * @param {number | bigint} [limit] Default value: 1, Max value: 200
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        queryUniversalTransferHistory: async (
            fromEmail?: string,
            toEmail?: string,
            clientTranId?: string,
            startTime?: number | bigint,
            endTime?: number | bigint,
            page?: number | bigint,
            limit?: number | bigint,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (fromEmail !== undefined && fromEmail !== null) {
                localVarQueryParameter['fromEmail'] = fromEmail;
            }
            if (toEmail !== undefined && toEmail !== null) {
                localVarQueryParameter['toEmail'] = toEmail;
            }
            if (clientTranId !== undefined && clientTranId !== null) {
                localVarQueryParameter['clientTranId'] = clientTranId;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (page !== undefined && page !== null) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined && limit !== null) {
                localVarQueryParameter['limit'] = limit;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/universalTransfer',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Sub-account Futures Asset Transfer
         *
         *
         * Master account can transfer max 2000 times a minute
         * There must be sufficient margin balance in futures wallet to execute transferring.
         *
         * Weight: 1
         *
         * @summary Sub-account Futures Asset Transfer (For Master Account) (USER_DATA)
         * @param {string} fromEmail
         * @param {string} toEmail
         * @param {number | bigint} futuresType 1:USDT-margined Futures，2: Coin-margined Futures
         * @param {string} asset
         * @param {number} amount
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        subAccountFuturesAssetTransfer: async (
            fromEmail: string,
            toEmail: string,
            futuresType: number | bigint,
            asset: string,
            amount: number,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'fromEmail' is not null or undefined
            assertParamExists('subAccountFuturesAssetTransfer', 'fromEmail', fromEmail);
            // verify required parameter 'toEmail' is not null or undefined
            assertParamExists('subAccountFuturesAssetTransfer', 'toEmail', toEmail);
            // verify required parameter 'futuresType' is not null or undefined
            assertParamExists('subAccountFuturesAssetTransfer', 'futuresType', futuresType);
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('subAccountFuturesAssetTransfer', 'asset', asset);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('subAccountFuturesAssetTransfer', 'amount', amount);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (fromEmail !== undefined && fromEmail !== null) {
                localVarQueryParameter['fromEmail'] = fromEmail;
            }
            if (toEmail !== undefined && toEmail !== null) {
                localVarQueryParameter['toEmail'] = toEmail;
            }
            if (futuresType !== undefined && futuresType !== null) {
                localVarQueryParameter['futuresType'] = futuresType;
            }
            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (amount !== undefined && amount !== null) {
                localVarQueryParameter['amount'] = amount;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/futures/internalTransfer',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Sub-account Transfer History
         *
         * If type is not sent, the records of type 2: transfer out will be returned by default.
         * If startTime and endTime are not sent, the recent 30-day data will be returned.
         *
         * Weight: 1
         *
         * @summary Sub-account Transfer History (For Sub-account) (USER_DATA)
         * @param {string} [asset] If not sent, result of all assets will be returned
         * @param {number | bigint} [type] 1: transfer in, 2: transfer out
         * @param {number | bigint} [startTime]
         * @param {number | bigint} [endTime]
         * @param {number | bigint} [limit] Default value: 1, Max value: 200
         * @param {boolean} [returnFailHistory] Default `False`, return PROCESS and SUCCESS status history; If `True`,return PROCESS and SUCCESS and FAILURE status history
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        subAccountTransferHistory: async (
            asset?: string,
            type?: number | bigint,
            startTime?: number | bigint,
            endTime?: number | bigint,
            limit?: number | bigint,
            returnFailHistory?: boolean,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (type !== undefined && type !== null) {
                localVarQueryParameter['type'] = type;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (limit !== undefined && limit !== null) {
                localVarQueryParameter['limit'] = limit;
            }
            if (returnFailHistory !== undefined && returnFailHistory !== null) {
                localVarQueryParameter['returnFailHistory'] = returnFailHistory;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/transfer/subUserHistory',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Transfer to Master
         *
         * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
         *
         * Weight: 1
         *
         * @summary Transfer to Master (For Sub-account) (USER_DATA)
         * @param {string} asset
         * @param {number} amount
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        transferToMaster: async (
            asset: string,
            amount: number,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('transferToMaster', 'asset', asset);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('transferToMaster', 'amount', amount);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (amount !== undefined && amount !== null) {
                localVarQueryParameter['amount'] = amount;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/transfer/subToMaster',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Transfer to Sub-account of Same Master
         *
         * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
         *
         * Weight: 1
         *
         * @summary Transfer to Sub-account of Same Master (For Sub-account) (USER_DATA)
         * @param {string} toEmail
         * @param {string} asset
         * @param {number} amount
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        transferToSubAccountOfSameMaster: async (
            toEmail: string,
            asset: string,
            amount: number,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'toEmail' is not null or undefined
            assertParamExists('transferToSubAccountOfSameMaster', 'toEmail', toEmail);
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('transferToSubAccountOfSameMaster', 'asset', asset);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('transferToSubAccountOfSameMaster', 'amount', amount);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (toEmail !== undefined && toEmail !== null) {
                localVarQueryParameter['toEmail'] = toEmail;
            }
            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (amount !== undefined && amount !== null) {
                localVarQueryParameter['amount'] = amount;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/transfer/subToSub',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Universal Transfer
         *
         * You need to enable "internal transfer" option for the api key which requests this endpoint.
         * Transfer from master account by default if fromEmail is not sent.
         * Transfer to master account by default if toEmail is not sent.
         * At least either fromEmail or toEmail need to be sent when the fromAccountType and the toAccountType are the same.
         * Supported transfer scenarios:
         * `SPOT` transfer to `SPOT`, `USDT_FUTURE`, `COIN_FUTURE` (regardless of master or sub)
         * `SPOT`, `USDT_FUTURE`, `COIN_FUTURE` transfer to `SPOT`  (regardless of master or sub)
         * Master account `SPOT` transfer to sub-account `MARGIN(Cross)`, `ISOLATED_MARGIN`
         * Sub-account `MARGIN(Cross)`, `ISOLATED_MARGIN` transfer to master account `SPOT`
         * Sub-account `MARGIN(Cross)` transfer to Sub-account `MARGIN(Cross)`
         * `ALPHA` to `ALPHA`  (regardless of master or sub)
         *
         * Weight: 360
         *
         * @summary Universal Transfer (For Master Account) (USER_DATA)
         * @param {string} fromAccountType "SPOT","USDT_FUTURE","COIN_FUTURE","MARGIN"(Cross),"ISOLATED_MARGIN"
         * @param {string} toAccountType "SPOT","USDT_FUTURE","COIN_FUTURE","MARGIN"(Cross),"ISOLATED_MARGIN"
         * @param {string} asset
         * @param {number} amount
         * @param {string} [fromEmail]
         * @param {string} [toEmail]
         * @param {string} [clientTranId]
         * @param {string} [symbol] Only supported under ISOLATED_MARGIN type
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        universalTransfer: async (
            fromAccountType: string,
            toAccountType: string,
            asset: string,
            amount: number,
            fromEmail?: string,
            toEmail?: string,
            clientTranId?: string,
            symbol?: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'fromAccountType' is not null or undefined
            assertParamExists('universalTransfer', 'fromAccountType', fromAccountType);
            // verify required parameter 'toAccountType' is not null or undefined
            assertParamExists('universalTransfer', 'toAccountType', toAccountType);
            // verify required parameter 'asset' is not null or undefined
            assertParamExists('universalTransfer', 'asset', asset);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('universalTransfer', 'amount', amount);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};

            if (fromEmail !== undefined && fromEmail !== null) {
                localVarQueryParameter['fromEmail'] = fromEmail;
            }
            if (toEmail !== undefined && toEmail !== null) {
                localVarQueryParameter['toEmail'] = toEmail;
            }
            if (fromAccountType !== undefined && fromAccountType !== null) {
                localVarQueryParameter['fromAccountType'] = fromAccountType;
            }
            if (toAccountType !== undefined && toAccountType !== null) {
                localVarQueryParameter['toAccountType'] = toAccountType;
            }
            if (clientTranId !== undefined && clientTranId !== null) {
                localVarQueryParameter['clientTranId'] = clientTranId;
            }
            if (symbol !== undefined && symbol !== null) {
                localVarQueryParameter['symbol'] = symbol;
            }
            if (asset !== undefined && asset !== null) {
                localVarQueryParameter['asset'] = asset;
            }
            if (amount !== undefined && amount !== null) {
                localVarQueryParameter['amount'] = amount;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/sapi/v1/sub-account/universalTransfer',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                timeUnit: _timeUnit,
            };
        },
    };
};

/**
 * AssetManagementApi - interface
 * @interface AssetManagementApi
 */
export interface AssetManagementApiInterface {
    /**
     * Futures Transfer for Sub-account
     *
     * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
     *
     * Weight: 1
     *
     * @summary Futures Transfer for Sub-account (For Master Account) (USER_DATA)
     * @param {FuturesTransferForSubAccountRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    futuresTransferForSubAccount(
        requestParameters: FuturesTransferForSubAccountRequest
    ): Promise<RestApiResponse<FuturesTransferForSubAccountResponse>>;
    /**
     * Get Detail on Sub-account's Futures Account
     *
     * Weight: 10
     *
     * @summary Get Detail on Sub-account\'s Futures Account (For Master Account) (USER_DATA)
     * @param {GetDetailOnSubAccountsFuturesAccountRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getDetailOnSubAccountsFuturesAccount(
        requestParameters: GetDetailOnSubAccountsFuturesAccountRequest
    ): Promise<RestApiResponse<GetDetailOnSubAccountsFuturesAccountResponse>>;
    /**
     * Get Detail on Sub-account's Futures Account
     *
     * Weight: 1
     *
     * @summary Get Detail on Sub-account\'s Futures Account V2 (For Master Account) (USER_DATA)
     * @param {GetDetailOnSubAccountsFuturesAccountV2Request} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getDetailOnSubAccountsFuturesAccountV2(
        requestParameters: GetDetailOnSubAccountsFuturesAccountV2Request
    ): Promise<RestApiResponse<GetDetailOnSubAccountsFuturesAccountV2Response>>;
    /**
     * Get Detail on Sub-account's Margin Account
     *
     * Weight: 10
     *
     * @summary Get Detail on Sub-account\'s Margin Account (For Master Account) (USER_DATA)
     * @param {GetDetailOnSubAccountsMarginAccountRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getDetailOnSubAccountsMarginAccount(
        requestParameters: GetDetailOnSubAccountsMarginAccountRequest
    ): Promise<RestApiResponse<GetDetailOnSubAccountsMarginAccountResponse>>;
    /**
     * Query move position history
     *
     * If `startTime` and `endTime` not sent, return records of the last 90 days by default with 1000 maximum limits
     * If `startTime` is sent and `endTime` is not sent, return records of [max(startTime, now-90d), now].
     * If `startTime` is not sent and `endTime` is sent, return records of [max(now,endTime-90d), endTime].
     *
     * Weight: 1
     *
     * @summary Get Move Position History for Sub-account (For Master Account) (USER_DATA)
     * @param {GetMovePositionHistoryForSubAccountRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getMovePositionHistoryForSubAccount(
        requestParameters: GetMovePositionHistoryForSubAccountRequest
    ): Promise<RestApiResponse<GetMovePositionHistoryForSubAccountResponse>>;
    /**
     * Fetch sub-account deposit address
     *
     * `amount` needs to be sent if using LIGHTNING network
     *
     * Weight: 1
     *
     * @summary Get Sub-account Deposit Address (For Master Account) (USER_DATA)
     * @param {GetSubAccountDepositAddressRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getSubAccountDepositAddress(
        requestParameters: GetSubAccountDepositAddressRequest
    ): Promise<RestApiResponse<GetSubAccountDepositAddressResponse>>;
    /**
     * Fetch sub-account deposit history
     *
     * Weight: 1
     *
     * @summary Get Sub-account Deposit History (For Master Account) (USER_DATA)
     * @param {GetSubAccountDepositHistoryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getSubAccountDepositHistory(
        requestParameters: GetSubAccountDepositHistoryRequest
    ): Promise<RestApiResponse<GetSubAccountDepositHistoryResponse>>;
    /**
     * Get Summary of Sub-account's Futures Account
     *
     * Weight: 1
     *
     * @summary Get Summary of Sub-account\'s Futures Account (For Master Account) (USER_DATA)
     * @param {GetSummaryOfSubAccountsFuturesAccountRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getSummaryOfSubAccountsFuturesAccount(
        requestParameters: GetSummaryOfSubAccountsFuturesAccountRequest
    ): Promise<RestApiResponse<GetSummaryOfSubAccountsFuturesAccountResponse>>;
    /**
     * Get Summary of Sub-account's Futures Account
     *
     * Weight: 10
     *
     * @summary Get Summary of Sub-account\'s Futures Account V2 (For Master Account) (USER_DATA)
     * @param {GetSummaryOfSubAccountsFuturesAccountV2Request} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getSummaryOfSubAccountsFuturesAccountV2(
        requestParameters: GetSummaryOfSubAccountsFuturesAccountV2Request
    ): Promise<RestApiResponse<GetSummaryOfSubAccountsFuturesAccountV2Response>>;
    /**
     * Get Summary of Sub-account's Margin Account
     *
     * Weight: 10
     *
     * @summary Get Summary of Sub-account\'s Margin Account (For Master Account) (USER_DATA)
     * @param {GetSummaryOfSubAccountsMarginAccountRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    getSummaryOfSubAccountsMarginAccount(
        requestParameters?: GetSummaryOfSubAccountsMarginAccountRequest
    ): Promise<RestApiResponse<GetSummaryOfSubAccountsMarginAccountResponse>>;
    /**
     * Margin Transfer for Sub-account
     *
     * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
     *
     * Weight: 1
     *
     * @summary Margin Transfer for Sub-account (For Master Account) (USER_DATA)
     * @param {MarginTransferForSubAccountRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    marginTransferForSubAccount(
        requestParameters: MarginTransferForSubAccountRequest
    ): Promise<RestApiResponse<MarginTransferForSubAccountResponse>>;
    /**
     * Move position between sub-master, master-sub, or sub-sub accounts when necessary
     *
     * You need to Enable Trading permission for the API Key which requests this endpoint.
     * This function only support VIP level 7-9.
     * Only master account can use the function
     * Quantity should be positive number only
     * The function support normal account, PM PRO, PM PRO SPAN and PM Retail.
     * Only support for from account has positions
     * For all orders in the same orderArgs request, if any symbol’s total close position quantity is bigger than the symbol’s current position quantity, all batch orders in the same list will fail simultaneously.
     * Only support cross margin mode
     * The price for move position is MarkPrice only.
     * Not support for MSA.
     * Not support for the symbol under Reduce-Only.
     *
     * Weight: 1
     *
     * @summary Move Position for Sub-account (For Master Account) (USER_DATA)
     * @param {MovePositionForSubAccountRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    movePositionForSubAccount(
        requestParameters: MovePositionForSubAccountRequest
    ): Promise<RestApiResponse<MovePositionForSubAccountResponse>>;
    /**
     * Fetch sub-account assets
     *
     * Weight: 60
     *
     * @summary Query Sub-account Assets (For Master Account) (USER_DATA)
     * @param {QuerySubAccountAssetsRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    querySubAccountAssets(
        requestParameters: QuerySubAccountAssetsRequest
    ): Promise<RestApiResponse<QuerySubAccountAssetsResponse>>;
    /**
     * Fetch sub-account assets
     *
     * Weight: 60
     *
     * @summary Query Sub-account Assets (For Master Account) (USER_DATA)
     * @param {QuerySubAccountAssetsAssetManagementRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    querySubAccountAssetsAssetManagement(
        requestParameters: QuerySubAccountAssetsAssetManagementRequest
    ): Promise<RestApiResponse<QuerySubAccountAssetsAssetManagementResponse>>;
    /**
     * Query Sub-account Futures Asset Transfer History
     *
     * Weight: 1
     *
     * @summary Query Sub-account Futures Asset Transfer History (For Master Account) (USER_DATA)
     * @param {QuerySubAccountFuturesAssetTransferHistoryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    querySubAccountFuturesAssetTransferHistory(
        requestParameters: QuerySubAccountFuturesAssetTransferHistoryRequest
    ): Promise<RestApiResponse<QuerySubAccountFuturesAssetTransferHistoryResponse>>;
    /**
     * Query Sub-account Spot Asset Transfer History
     *
     * fromEmail and toEmail cannot be sent at the same time.
     * Return fromEmail equal master account email by default.
     *
     * Weight: 1
     *
     * @summary Query Sub-account Spot Asset Transfer History (For Master Account) (USER_DATA)
     * @param {QuerySubAccountSpotAssetTransferHistoryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    querySubAccountSpotAssetTransferHistory(
        requestParameters?: QuerySubAccountSpotAssetTransferHistoryRequest
    ): Promise<RestApiResponse<QuerySubAccountSpotAssetTransferHistoryResponse>>;
    /**
     * Get BTC valued asset summary of subaccounts.
     *
     * Weight: 1
     *
     * @summary Query Sub-account Spot Assets Summary (For Master Account) (USER_DATA)
     * @param {QuerySubAccountSpotAssetsSummaryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    querySubAccountSpotAssetsSummary(
        requestParameters?: QuerySubAccountSpotAssetsSummaryRequest
    ): Promise<RestApiResponse<QuerySubAccountSpotAssetsSummaryResponse>>;
    /**
     * Query Universal Transfer History
     *
     * fromEmail and toEmail cannot be sent at the same time.
     * Return fromEmail equal master account email by default.
     * The query time period must be less than 7 days.
     * If startTime and endTime not sent, return records of the last 7 days by default.
     *
     * Weight: 1
     *
     * @summary Query Universal Transfer History (For Master Account) (USER_DATA)
     * @param {QueryUniversalTransferHistoryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    queryUniversalTransferHistory(
        requestParameters?: QueryUniversalTransferHistoryRequest
    ): Promise<RestApiResponse<QueryUniversalTransferHistoryResponse>>;
    /**
     * Sub-account Futures Asset Transfer
     *
     *
     * Master account can transfer max 2000 times a minute
     * There must be sufficient margin balance in futures wallet to execute transferring.
     *
     * Weight: 1
     *
     * @summary Sub-account Futures Asset Transfer (For Master Account) (USER_DATA)
     * @param {SubAccountFuturesAssetTransferRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    subAccountFuturesAssetTransfer(
        requestParameters: SubAccountFuturesAssetTransferRequest
    ): Promise<RestApiResponse<SubAccountFuturesAssetTransferResponse>>;
    /**
     * Sub-account Transfer History
     *
     * If type is not sent, the records of type 2: transfer out will be returned by default.
     * If startTime and endTime are not sent, the recent 30-day data will be returned.
     *
     * Weight: 1
     *
     * @summary Sub-account Transfer History (For Sub-account) (USER_DATA)
     * @param {SubAccountTransferHistoryRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    subAccountTransferHistory(
        requestParameters?: SubAccountTransferHistoryRequest
    ): Promise<RestApiResponse<SubAccountTransferHistoryResponse>>;
    /**
     * Transfer to Master
     *
     * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
     *
     * Weight: 1
     *
     * @summary Transfer to Master (For Sub-account) (USER_DATA)
     * @param {TransferToMasterRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    transferToMaster(
        requestParameters: TransferToMasterRequest
    ): Promise<RestApiResponse<TransferToMasterResponse>>;
    /**
     * Transfer to Sub-account of Same Master
     *
     * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
     *
     * Weight: 1
     *
     * @summary Transfer to Sub-account of Same Master (For Sub-account) (USER_DATA)
     * @param {TransferToSubAccountOfSameMasterRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    transferToSubAccountOfSameMaster(
        requestParameters: TransferToSubAccountOfSameMasterRequest
    ): Promise<RestApiResponse<TransferToSubAccountOfSameMasterResponse>>;
    /**
     * Universal Transfer
     *
     * You need to enable "internal transfer" option for the api key which requests this endpoint.
     * Transfer from master account by default if fromEmail is not sent.
     * Transfer to master account by default if toEmail is not sent.
     * At least either fromEmail or toEmail need to be sent when the fromAccountType and the toAccountType are the same.
     * Supported transfer scenarios:
     * `SPOT` transfer to `SPOT`, `USDT_FUTURE`, `COIN_FUTURE` (regardless of master or sub)
     * `SPOT`, `USDT_FUTURE`, `COIN_FUTURE` transfer to `SPOT`  (regardless of master or sub)
     * Master account `SPOT` transfer to sub-account `MARGIN(Cross)`, `ISOLATED_MARGIN`
     * Sub-account `MARGIN(Cross)`, `ISOLATED_MARGIN` transfer to master account `SPOT`
     * Sub-account `MARGIN(Cross)` transfer to Sub-account `MARGIN(Cross)`
     * `ALPHA` to `ALPHA`  (regardless of master or sub)
     *
     * Weight: 360
     *
     * @summary Universal Transfer (For Master Account) (USER_DATA)
     * @param {UniversalTransferRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApiInterface
     */
    universalTransfer(
        requestParameters: UniversalTransferRequest
    ): Promise<RestApiResponse<UniversalTransferResponse>>;
}

/**
 * Request parameters for futuresTransferForSubAccount operation in AssetManagementApi.
 * @interface FuturesTransferForSubAccountRequest
 */
export interface FuturesTransferForSubAccountRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiFuturesTransferForSubAccount
     */
    readonly email: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiFuturesTransferForSubAccount
     */
    readonly asset: string;

    /**
     *
     * @type {number}
     * @memberof AssetManagementApiFuturesTransferForSubAccount
     */
    readonly amount: number;

    /**
     * 1: transfer from subaccount's  spot account to margin account 2: transfer from subaccount's margin account to its spot account
     * @type {number | bigint}
     * @memberof AssetManagementApiFuturesTransferForSubAccount
     */
    readonly type: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiFuturesTransferForSubAccount
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getDetailOnSubAccountsFuturesAccount operation in AssetManagementApi.
 * @interface GetDetailOnSubAccountsFuturesAccountRequest
 */
export interface GetDetailOnSubAccountsFuturesAccountRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiGetDetailOnSubAccountsFuturesAccount
     */
    readonly email: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetDetailOnSubAccountsFuturesAccount
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getDetailOnSubAccountsFuturesAccountV2 operation in AssetManagementApi.
 * @interface GetDetailOnSubAccountsFuturesAccountV2Request
 */
export interface GetDetailOnSubAccountsFuturesAccountV2Request {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiGetDetailOnSubAccountsFuturesAccountV2
     */
    readonly email: string;

    /**
     * 1:USDT-margined Futures，2: Coin-margined Futures
     * @type {number | bigint}
     * @memberof AssetManagementApiGetDetailOnSubAccountsFuturesAccountV2
     */
    readonly futuresType: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetDetailOnSubAccountsFuturesAccountV2
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getDetailOnSubAccountsMarginAccount operation in AssetManagementApi.
 * @interface GetDetailOnSubAccountsMarginAccountRequest
 */
export interface GetDetailOnSubAccountsMarginAccountRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiGetDetailOnSubAccountsMarginAccount
     */
    readonly email: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetDetailOnSubAccountsMarginAccount
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getMovePositionHistoryForSubAccount operation in AssetManagementApi.
 * @interface GetMovePositionHistoryForSubAccountRequest
 */
export interface GetMovePositionHistoryForSubAccountRequest {
    /**
     *
     * @type {string}
     * @memberof AssetManagementApiGetMovePositionHistoryForSubAccount
     */
    readonly symbol: string;

    /**
     * Page
     * @type {number | bigint}
     * @memberof AssetManagementApiGetMovePositionHistoryForSubAccount
     */
    readonly page: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetMovePositionHistoryForSubAccount
     */
    readonly row: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetMovePositionHistoryForSubAccount
     */
    readonly startTime?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetMovePositionHistoryForSubAccount
     */
    readonly endTime?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetMovePositionHistoryForSubAccount
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getSubAccountDepositAddress operation in AssetManagementApi.
 * @interface GetSubAccountDepositAddressRequest
 */
export interface GetSubAccountDepositAddressRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiGetSubAccountDepositAddress
     */
    readonly email: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiGetSubAccountDepositAddress
     */
    readonly coin: string;

    /**
     * networks can be found in `GET /sapi/v1/capital/deposit/address`
     * @type {string}
     * @memberof AssetManagementApiGetSubAccountDepositAddress
     */
    readonly network?: string;

    /**
     *
     * @type {number}
     * @memberof AssetManagementApiGetSubAccountDepositAddress
     */
    readonly amount?: number;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSubAccountDepositAddress
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getSubAccountDepositHistory operation in AssetManagementApi.
 * @interface GetSubAccountDepositHistoryRequest
 */
export interface GetSubAccountDepositHistoryRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly email: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly coin?: string;

    /**
     * 0(0:pending,6: credited but cannot withdraw,7:Wrong Deposit,8:Waiting User confirm,1:success)
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly status?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly startTime?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly endTime?: number | bigint;

    /**
     * Default value: 1, Max value: 200
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly limit?: number | bigint;

    /**
     * default:0
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly offset?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly recvWindow?: number | bigint;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiGetSubAccountDepositHistory
     */
    readonly txId?: string;
}

/**
 * Request parameters for getSummaryOfSubAccountsFuturesAccount operation in AssetManagementApi.
 * @interface GetSummaryOfSubAccountsFuturesAccountRequest
 */
export interface GetSummaryOfSubAccountsFuturesAccountRequest {
    /**
     * Page
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSummaryOfSubAccountsFuturesAccount
     */
    readonly page: number | bigint;

    /**
     * Limit (Max: 500)
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSummaryOfSubAccountsFuturesAccount
     */
    readonly limit: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSummaryOfSubAccountsFuturesAccount
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getSummaryOfSubAccountsFuturesAccountV2 operation in AssetManagementApi.
 * @interface GetSummaryOfSubAccountsFuturesAccountV2Request
 */
export interface GetSummaryOfSubAccountsFuturesAccountV2Request {
    /**
     * 1:USDT-margined Futures，2: Coin-margined Futures
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSummaryOfSubAccountsFuturesAccountV2
     */
    readonly futuresType: number | bigint;

    /**
     * Default value: 1
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSummaryOfSubAccountsFuturesAccountV2
     */
    readonly page?: number | bigint;

    /**
     * Default value: 1, Max value: 200
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSummaryOfSubAccountsFuturesAccountV2
     */
    readonly limit?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSummaryOfSubAccountsFuturesAccountV2
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for getSummaryOfSubAccountsMarginAccount operation in AssetManagementApi.
 * @interface GetSummaryOfSubAccountsMarginAccountRequest
 */
export interface GetSummaryOfSubAccountsMarginAccountRequest {
    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiGetSummaryOfSubAccountsMarginAccount
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for marginTransferForSubAccount operation in AssetManagementApi.
 * @interface MarginTransferForSubAccountRequest
 */
export interface MarginTransferForSubAccountRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiMarginTransferForSubAccount
     */
    readonly email: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiMarginTransferForSubAccount
     */
    readonly asset: string;

    /**
     *
     * @type {number}
     * @memberof AssetManagementApiMarginTransferForSubAccount
     */
    readonly amount: number;

    /**
     * 1: transfer from subaccount's  spot account to margin account 2: transfer from subaccount's margin account to its spot account
     * @type {number | bigint}
     * @memberof AssetManagementApiMarginTransferForSubAccount
     */
    readonly type: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiMarginTransferForSubAccount
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for movePositionForSubAccount operation in AssetManagementApi.
 * @interface MovePositionForSubAccountRequest
 */
export interface MovePositionForSubAccountRequest {
    /**
     *
     * @type {string}
     * @memberof AssetManagementApiMovePositionForSubAccount
     */
    readonly fromUserEmail: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiMovePositionForSubAccount
     */
    readonly toUserEmail: string;

    /**
     * Only support UM
     * @type {string}
     * @memberof AssetManagementApiMovePositionForSubAccount
     */
    readonly productType: string;

    /**
     * Max 10 positions supported. When input request parameter,orderArgs.symbol should be STRING, orderArgs.quantity should be BIGDECIMAL, and orderArgs.positionSide should be STRING, positionSide support BOTH,LONG and SHORT. Each entry should be like orderArgs[0].symbol=BTCUSDT,orderArgs[0].quantity=0.001,orderArgs[0].positionSide=BOTH. Example of the request parameter array: orderArgs[0].symbol=BTCUSDT orderArgs[0].quantity=0.001 orderArgs[0].positionSide=BOTH orderArgs[1].symbol=ETHUSDT orderArgs[1].quantity=0.01 orderArgs[1].positionSide=BOTH
     * @type {Array<MovePositionForSubAccountOrderArgsParameterInner>}
     * @memberof AssetManagementApiMovePositionForSubAccount
     */
    readonly orderArgs: Array<MovePositionForSubAccountOrderArgsParameterInner>;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiMovePositionForSubAccount
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for querySubAccountAssets operation in AssetManagementApi.
 * @interface QuerySubAccountAssetsRequest
 */
export interface QuerySubAccountAssetsRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiQuerySubAccountAssets
     */
    readonly email: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountAssets
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for querySubAccountAssetsAssetManagement operation in AssetManagementApi.
 * @interface QuerySubAccountAssetsAssetManagementRequest
 */
export interface QuerySubAccountAssetsAssetManagementRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiQuerySubAccountAssetsAssetManagement
     */
    readonly email: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountAssetsAssetManagement
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for querySubAccountFuturesAssetTransferHistory operation in AssetManagementApi.
 * @interface QuerySubAccountFuturesAssetTransferHistoryRequest
 */
export interface QuerySubAccountFuturesAssetTransferHistoryRequest {
    /**
     * [Sub-account email](#email-address)
     * @type {string}
     * @memberof AssetManagementApiQuerySubAccountFuturesAssetTransferHistory
     */
    readonly email: string;

    /**
     * 1:USDT-margined Futures，2: Coin-margined Futures
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountFuturesAssetTransferHistory
     */
    readonly futuresType: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountFuturesAssetTransferHistory
     */
    readonly startTime?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountFuturesAssetTransferHistory
     */
    readonly endTime?: number | bigint;

    /**
     * Default value: 1
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountFuturesAssetTransferHistory
     */
    readonly page?: number | bigint;

    /**
     * Default value: 1, Max value: 200
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountFuturesAssetTransferHistory
     */
    readonly limit?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountFuturesAssetTransferHistory
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for querySubAccountSpotAssetTransferHistory operation in AssetManagementApi.
 * @interface QuerySubAccountSpotAssetTransferHistoryRequest
 */
export interface QuerySubAccountSpotAssetTransferHistoryRequest {
    /**
     *
     * @type {string}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetTransferHistory
     */
    readonly fromEmail?: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetTransferHistory
     */
    readonly toEmail?: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetTransferHistory
     */
    readonly startTime?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetTransferHistory
     */
    readonly endTime?: number | bigint;

    /**
     * Default value: 1
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetTransferHistory
     */
    readonly page?: number | bigint;

    /**
     * Default value: 1, Max value: 200
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetTransferHistory
     */
    readonly limit?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetTransferHistory
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for querySubAccountSpotAssetsSummary operation in AssetManagementApi.
 * @interface QuerySubAccountSpotAssetsSummaryRequest
 */
export interface QuerySubAccountSpotAssetsSummaryRequest {
    /**
     * Managed sub-account email
     * @type {string}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetsSummary
     */
    readonly email?: string;

    /**
     * Default value: 1
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetsSummary
     */
    readonly page?: number | bigint;

    /**
     * default 10, max 20
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetsSummary
     */
    readonly size?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQuerySubAccountSpotAssetsSummary
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for queryUniversalTransferHistory operation in AssetManagementApi.
 * @interface QueryUniversalTransferHistoryRequest
 */
export interface QueryUniversalTransferHistoryRequest {
    /**
     *
     * @type {string}
     * @memberof AssetManagementApiQueryUniversalTransferHistory
     */
    readonly fromEmail?: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiQueryUniversalTransferHistory
     */
    readonly toEmail?: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiQueryUniversalTransferHistory
     */
    readonly clientTranId?: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQueryUniversalTransferHistory
     */
    readonly startTime?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQueryUniversalTransferHistory
     */
    readonly endTime?: number | bigint;

    /**
     * Default value: 1
     * @type {number | bigint}
     * @memberof AssetManagementApiQueryUniversalTransferHistory
     */
    readonly page?: number | bigint;

    /**
     * Default value: 1, Max value: 200
     * @type {number | bigint}
     * @memberof AssetManagementApiQueryUniversalTransferHistory
     */
    readonly limit?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiQueryUniversalTransferHistory
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for subAccountFuturesAssetTransfer operation in AssetManagementApi.
 * @interface SubAccountFuturesAssetTransferRequest
 */
export interface SubAccountFuturesAssetTransferRequest {
    /**
     *
     * @type {string}
     * @memberof AssetManagementApiSubAccountFuturesAssetTransfer
     */
    readonly fromEmail: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiSubAccountFuturesAssetTransfer
     */
    readonly toEmail: string;

    /**
     * 1:USDT-margined Futures，2: Coin-margined Futures
     * @type {number | bigint}
     * @memberof AssetManagementApiSubAccountFuturesAssetTransfer
     */
    readonly futuresType: number | bigint;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiSubAccountFuturesAssetTransfer
     */
    readonly asset: string;

    /**
     *
     * @type {number}
     * @memberof AssetManagementApiSubAccountFuturesAssetTransfer
     */
    readonly amount: number;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiSubAccountFuturesAssetTransfer
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for subAccountTransferHistory operation in AssetManagementApi.
 * @interface SubAccountTransferHistoryRequest
 */
export interface SubAccountTransferHistoryRequest {
    /**
     * If not sent, result of all assets will be returned
     * @type {string}
     * @memberof AssetManagementApiSubAccountTransferHistory
     */
    readonly asset?: string;

    /**
     * 1: transfer in, 2: transfer out
     * @type {number | bigint}
     * @memberof AssetManagementApiSubAccountTransferHistory
     */
    readonly type?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiSubAccountTransferHistory
     */
    readonly startTime?: number | bigint;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiSubAccountTransferHistory
     */
    readonly endTime?: number | bigint;

    /**
     * Default value: 1, Max value: 200
     * @type {number | bigint}
     * @memberof AssetManagementApiSubAccountTransferHistory
     */
    readonly limit?: number | bigint;

    /**
     * Default `False`, return PROCESS and SUCCESS status history; If `True`,return PROCESS and SUCCESS and FAILURE status history
     * @type {boolean}
     * @memberof AssetManagementApiSubAccountTransferHistory
     */
    readonly returnFailHistory?: boolean;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiSubAccountTransferHistory
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for transferToMaster operation in AssetManagementApi.
 * @interface TransferToMasterRequest
 */
export interface TransferToMasterRequest {
    /**
     *
     * @type {string}
     * @memberof AssetManagementApiTransferToMaster
     */
    readonly asset: string;

    /**
     *
     * @type {number}
     * @memberof AssetManagementApiTransferToMaster
     */
    readonly amount: number;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiTransferToMaster
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for transferToSubAccountOfSameMaster operation in AssetManagementApi.
 * @interface TransferToSubAccountOfSameMasterRequest
 */
export interface TransferToSubAccountOfSameMasterRequest {
    /**
     *
     * @type {string}
     * @memberof AssetManagementApiTransferToSubAccountOfSameMaster
     */
    readonly toEmail: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiTransferToSubAccountOfSameMaster
     */
    readonly asset: string;

    /**
     *
     * @type {number}
     * @memberof AssetManagementApiTransferToSubAccountOfSameMaster
     */
    readonly amount: number;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiTransferToSubAccountOfSameMaster
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for universalTransfer operation in AssetManagementApi.
 * @interface UniversalTransferRequest
 */
export interface UniversalTransferRequest {
    /**
     * "SPOT","USDT_FUTURE","COIN_FUTURE","MARGIN"(Cross),"ISOLATED_MARGIN"
     * @type {string}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly fromAccountType: string;

    /**
     * "SPOT","USDT_FUTURE","COIN_FUTURE","MARGIN"(Cross),"ISOLATED_MARGIN"
     * @type {string}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly toAccountType: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly asset: string;

    /**
     *
     * @type {number}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly amount: number;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly fromEmail?: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly toEmail?: string;

    /**
     *
     * @type {string}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly clientTranId?: string;

    /**
     * Only supported under ISOLATED_MARGIN type
     * @type {string}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly symbol?: string;

    /**
     *
     * @type {number | bigint}
     * @memberof AssetManagementApiUniversalTransfer
     */
    readonly recvWindow?: number | bigint;
}

/**
 * AssetManagementApi - object-oriented interface
 * @class AssetManagementApi
 */
export class AssetManagementApi implements AssetManagementApiInterface {
    private readonly configuration: ConfigurationRestAPI;
    private localVarAxiosParamCreator;

    constructor(configuration: ConfigurationRestAPI) {
        this.configuration = configuration;
        this.localVarAxiosParamCreator = AssetManagementApiAxiosParamCreator(configuration);
    }

    /**
     * Futures Transfer for Sub-account
     *
     * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
     *
     * Weight: 1
     *
     * @summary Futures Transfer for Sub-account (For Master Account) (USER_DATA)
     * @param {FuturesTransferForSubAccountRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<FuturesTransferForSubAccountResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Futures-Transfer-for-Sub-account Binance API Documentation}
     */
    public async futuresTransferForSubAccount(
        requestParameters: FuturesTransferForSubAccountRequest
    ): Promise<RestApiResponse<FuturesTransferForSubAccountResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.futuresTransferForSubAccount(
            requestParameters?.email,
            requestParameters?.asset,
            requestParameters?.amount,
            requestParameters?.type,
            requestParameters?.recvWindow
        );
        return sendRequest<FuturesTransferForSubAccountResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Get Detail on Sub-account's Futures Account
     *
     * Weight: 10
     *
     * @summary Get Detail on Sub-account\'s Futures Account (For Master Account) (USER_DATA)
     * @param {GetDetailOnSubAccountsFuturesAccountRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetDetailOnSubAccountsFuturesAccountResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Detail-on-Sub-accounts-Futures-Account Binance API Documentation}
     */
    public async getDetailOnSubAccountsFuturesAccount(
        requestParameters: GetDetailOnSubAccountsFuturesAccountRequest
    ): Promise<RestApiResponse<GetDetailOnSubAccountsFuturesAccountResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.getDetailOnSubAccountsFuturesAccount(
                requestParameters?.email,
                requestParameters?.recvWindow
            );
        return sendRequest<GetDetailOnSubAccountsFuturesAccountResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Get Detail on Sub-account's Futures Account
     *
     * Weight: 1
     *
     * @summary Get Detail on Sub-account\'s Futures Account V2 (For Master Account) (USER_DATA)
     * @param {GetDetailOnSubAccountsFuturesAccountV2Request} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetDetailOnSubAccountsFuturesAccountV2Response>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Detail-on-Sub-accounts-Futures-Account-V2 Binance API Documentation}
     */
    public async getDetailOnSubAccountsFuturesAccountV2(
        requestParameters: GetDetailOnSubAccountsFuturesAccountV2Request
    ): Promise<RestApiResponse<GetDetailOnSubAccountsFuturesAccountV2Response>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.getDetailOnSubAccountsFuturesAccountV2(
                requestParameters?.email,
                requestParameters?.futuresType,
                requestParameters?.recvWindow
            );
        return sendRequest<GetDetailOnSubAccountsFuturesAccountV2Response>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Get Detail on Sub-account's Margin Account
     *
     * Weight: 10
     *
     * @summary Get Detail on Sub-account\'s Margin Account (For Master Account) (USER_DATA)
     * @param {GetDetailOnSubAccountsMarginAccountRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetDetailOnSubAccountsMarginAccountResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Detail-on-Sub-accounts-Margin-Account Binance API Documentation}
     */
    public async getDetailOnSubAccountsMarginAccount(
        requestParameters: GetDetailOnSubAccountsMarginAccountRequest
    ): Promise<RestApiResponse<GetDetailOnSubAccountsMarginAccountResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.getDetailOnSubAccountsMarginAccount(
                requestParameters?.email,
                requestParameters?.recvWindow
            );
        return sendRequest<GetDetailOnSubAccountsMarginAccountResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Query move position history
     *
     * If `startTime` and `endTime` not sent, return records of the last 90 days by default with 1000 maximum limits
     * If `startTime` is sent and `endTime` is not sent, return records of [max(startTime, now-90d), now].
     * If `startTime` is not sent and `endTime` is sent, return records of [max(now,endTime-90d), endTime].
     *
     * Weight: 1
     *
     * @summary Get Move Position History for Sub-account (For Master Account) (USER_DATA)
     * @param {GetMovePositionHistoryForSubAccountRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetMovePositionHistoryForSubAccountResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Move-Position-History-for-Sub-account Binance API Documentation}
     */
    public async getMovePositionHistoryForSubAccount(
        requestParameters: GetMovePositionHistoryForSubAccountRequest
    ): Promise<RestApiResponse<GetMovePositionHistoryForSubAccountResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.getMovePositionHistoryForSubAccount(
                requestParameters?.symbol,
                requestParameters?.page,
                requestParameters?.row,
                requestParameters?.startTime,
                requestParameters?.endTime,
                requestParameters?.recvWindow
            );
        return sendRequest<GetMovePositionHistoryForSubAccountResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Fetch sub-account deposit address
     *
     * `amount` needs to be sent if using LIGHTNING network
     *
     * Weight: 1
     *
     * @summary Get Sub-account Deposit Address (For Master Account) (USER_DATA)
     * @param {GetSubAccountDepositAddressRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetSubAccountDepositAddressResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Sub-account-Deposit-Address Binance API Documentation}
     */
    public async getSubAccountDepositAddress(
        requestParameters: GetSubAccountDepositAddressRequest
    ): Promise<RestApiResponse<GetSubAccountDepositAddressResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.getSubAccountDepositAddress(
            requestParameters?.email,
            requestParameters?.coin,
            requestParameters?.network,
            requestParameters?.amount,
            requestParameters?.recvWindow
        );
        return sendRequest<GetSubAccountDepositAddressResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Fetch sub-account deposit history
     *
     * Weight: 1
     *
     * @summary Get Sub-account Deposit History (For Master Account) (USER_DATA)
     * @param {GetSubAccountDepositHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetSubAccountDepositHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Sub-account-Deposit-History Binance API Documentation}
     */
    public async getSubAccountDepositHistory(
        requestParameters: GetSubAccountDepositHistoryRequest
    ): Promise<RestApiResponse<GetSubAccountDepositHistoryResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.getSubAccountDepositHistory(
            requestParameters?.email,
            requestParameters?.coin,
            requestParameters?.status,
            requestParameters?.startTime,
            requestParameters?.endTime,
            requestParameters?.limit,
            requestParameters?.offset,
            requestParameters?.recvWindow,
            requestParameters?.txId
        );
        return sendRequest<GetSubAccountDepositHistoryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Get Summary of Sub-account's Futures Account
     *
     * Weight: 1
     *
     * @summary Get Summary of Sub-account\'s Futures Account (For Master Account) (USER_DATA)
     * @param {GetSummaryOfSubAccountsFuturesAccountRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetSummaryOfSubAccountsFuturesAccountResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Summary-of-Sub-accounts-Futures-Account Binance API Documentation}
     */
    public async getSummaryOfSubAccountsFuturesAccount(
        requestParameters: GetSummaryOfSubAccountsFuturesAccountRequest
    ): Promise<RestApiResponse<GetSummaryOfSubAccountsFuturesAccountResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.getSummaryOfSubAccountsFuturesAccount(
                requestParameters?.page,
                requestParameters?.limit,
                requestParameters?.recvWindow
            );
        return sendRequest<GetSummaryOfSubAccountsFuturesAccountResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Get Summary of Sub-account's Futures Account
     *
     * Weight: 10
     *
     * @summary Get Summary of Sub-account\'s Futures Account V2 (For Master Account) (USER_DATA)
     * @param {GetSummaryOfSubAccountsFuturesAccountV2Request} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetSummaryOfSubAccountsFuturesAccountV2Response>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Summary-of-Sub-accounts-Futures-Account-V2 Binance API Documentation}
     */
    public async getSummaryOfSubAccountsFuturesAccountV2(
        requestParameters: GetSummaryOfSubAccountsFuturesAccountV2Request
    ): Promise<RestApiResponse<GetSummaryOfSubAccountsFuturesAccountV2Response>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.getSummaryOfSubAccountsFuturesAccountV2(
                requestParameters?.futuresType,
                requestParameters?.page,
                requestParameters?.limit,
                requestParameters?.recvWindow
            );
        return sendRequest<GetSummaryOfSubAccountsFuturesAccountV2Response>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Get Summary of Sub-account's Margin Account
     *
     * Weight: 10
     *
     * @summary Get Summary of Sub-account\'s Margin Account (For Master Account) (USER_DATA)
     * @param {GetSummaryOfSubAccountsMarginAccountRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<GetSummaryOfSubAccountsMarginAccountResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Get-Summary-of-Sub-accounts-Margin-Account Binance API Documentation}
     */
    public async getSummaryOfSubAccountsMarginAccount(
        requestParameters: GetSummaryOfSubAccountsMarginAccountRequest = {}
    ): Promise<RestApiResponse<GetSummaryOfSubAccountsMarginAccountResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.getSummaryOfSubAccountsMarginAccount(
                requestParameters?.recvWindow
            );
        return sendRequest<GetSummaryOfSubAccountsMarginAccountResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Margin Transfer for Sub-account
     *
     * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
     *
     * Weight: 1
     *
     * @summary Margin Transfer for Sub-account (For Master Account) (USER_DATA)
     * @param {MarginTransferForSubAccountRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<MarginTransferForSubAccountResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Margin-Transfer-for-Sub-account Binance API Documentation}
     */
    public async marginTransferForSubAccount(
        requestParameters: MarginTransferForSubAccountRequest
    ): Promise<RestApiResponse<MarginTransferForSubAccountResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.marginTransferForSubAccount(
            requestParameters?.email,
            requestParameters?.asset,
            requestParameters?.amount,
            requestParameters?.type,
            requestParameters?.recvWindow
        );
        return sendRequest<MarginTransferForSubAccountResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Move position between sub-master, master-sub, or sub-sub accounts when necessary
     *
     * You need to Enable Trading permission for the API Key which requests this endpoint.
     * This function only support VIP level 7-9.
     * Only master account can use the function
     * Quantity should be positive number only
     * The function support normal account, PM PRO, PM PRO SPAN and PM Retail.
     * Only support for from account has positions
     * For all orders in the same orderArgs request, if any symbol’s total close position quantity is bigger than the symbol’s current position quantity, all batch orders in the same list will fail simultaneously.
     * Only support cross margin mode
     * The price for move position is MarkPrice only.
     * Not support for MSA.
     * Not support for the symbol under Reduce-Only.
     *
     * Weight: 1
     *
     * @summary Move Position for Sub-account (For Master Account) (USER_DATA)
     * @param {MovePositionForSubAccountRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<MovePositionForSubAccountResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Move-Position-for-Sub-account Binance API Documentation}
     */
    public async movePositionForSubAccount(
        requestParameters: MovePositionForSubAccountRequest
    ): Promise<RestApiResponse<MovePositionForSubAccountResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.movePositionForSubAccount(
            requestParameters?.fromUserEmail,
            requestParameters?.toUserEmail,
            requestParameters?.productType,
            requestParameters?.orderArgs,
            requestParameters?.recvWindow
        );
        return sendRequest<MovePositionForSubAccountResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Fetch sub-account assets
     *
     * Weight: 60
     *
     * @summary Query Sub-account Assets (For Master Account) (USER_DATA)
     * @param {QuerySubAccountAssetsRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<QuerySubAccountAssetsResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Query-Sub-account-Assets-V4 Binance API Documentation}
     */
    public async querySubAccountAssets(
        requestParameters: QuerySubAccountAssetsRequest
    ): Promise<RestApiResponse<QuerySubAccountAssetsResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.querySubAccountAssets(
            requestParameters?.email,
            requestParameters?.recvWindow
        );
        return sendRequest<QuerySubAccountAssetsResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Fetch sub-account assets
     *
     * Weight: 60
     *
     * @summary Query Sub-account Assets (For Master Account) (USER_DATA)
     * @param {QuerySubAccountAssetsAssetManagementRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<QuerySubAccountAssetsAssetManagementResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Query-Sub-account-Assets-V4 Binance API Documentation}
     */
    public async querySubAccountAssetsAssetManagement(
        requestParameters: QuerySubAccountAssetsAssetManagementRequest
    ): Promise<RestApiResponse<QuerySubAccountAssetsAssetManagementResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.querySubAccountAssetsAssetManagement(
                requestParameters?.email,
                requestParameters?.recvWindow
            );
        return sendRequest<QuerySubAccountAssetsAssetManagementResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Query Sub-account Futures Asset Transfer History
     *
     * Weight: 1
     *
     * @summary Query Sub-account Futures Asset Transfer History (For Master Account) (USER_DATA)
     * @param {QuerySubAccountFuturesAssetTransferHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<QuerySubAccountFuturesAssetTransferHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Query-Sub-account-Futures-Asset-Transfer-History Binance API Documentation}
     */
    public async querySubAccountFuturesAssetTransferHistory(
        requestParameters: QuerySubAccountFuturesAssetTransferHistoryRequest
    ): Promise<RestApiResponse<QuerySubAccountFuturesAssetTransferHistoryResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.querySubAccountFuturesAssetTransferHistory(
                requestParameters?.email,
                requestParameters?.futuresType,
                requestParameters?.startTime,
                requestParameters?.endTime,
                requestParameters?.page,
                requestParameters?.limit,
                requestParameters?.recvWindow
            );
        return sendRequest<QuerySubAccountFuturesAssetTransferHistoryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Query Sub-account Spot Asset Transfer History
     *
     * fromEmail and toEmail cannot be sent at the same time.
     * Return fromEmail equal master account email by default.
     *
     * Weight: 1
     *
     * @summary Query Sub-account Spot Asset Transfer History (For Master Account) (USER_DATA)
     * @param {QuerySubAccountSpotAssetTransferHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<QuerySubAccountSpotAssetTransferHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Query-Sub-account-Spot-Asset-Transfer-History Binance API Documentation}
     */
    public async querySubAccountSpotAssetTransferHistory(
        requestParameters: QuerySubAccountSpotAssetTransferHistoryRequest = {}
    ): Promise<RestApiResponse<QuerySubAccountSpotAssetTransferHistoryResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.querySubAccountSpotAssetTransferHistory(
                requestParameters?.fromEmail,
                requestParameters?.toEmail,
                requestParameters?.startTime,
                requestParameters?.endTime,
                requestParameters?.page,
                requestParameters?.limit,
                requestParameters?.recvWindow
            );
        return sendRequest<QuerySubAccountSpotAssetTransferHistoryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Get BTC valued asset summary of subaccounts.
     *
     * Weight: 1
     *
     * @summary Query Sub-account Spot Assets Summary (For Master Account) (USER_DATA)
     * @param {QuerySubAccountSpotAssetsSummaryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<QuerySubAccountSpotAssetsSummaryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Query-Sub-account-Spot-Assets-Summary Binance API Documentation}
     */
    public async querySubAccountSpotAssetsSummary(
        requestParameters: QuerySubAccountSpotAssetsSummaryRequest = {}
    ): Promise<RestApiResponse<QuerySubAccountSpotAssetsSummaryResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.querySubAccountSpotAssetsSummary(
                requestParameters?.email,
                requestParameters?.page,
                requestParameters?.size,
                requestParameters?.recvWindow
            );
        return sendRequest<QuerySubAccountSpotAssetsSummaryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Query Universal Transfer History
     *
     * fromEmail and toEmail cannot be sent at the same time.
     * Return fromEmail equal master account email by default.
     * The query time period must be less than 7 days.
     * If startTime and endTime not sent, return records of the last 7 days by default.
     *
     * Weight: 1
     *
     * @summary Query Universal Transfer History (For Master Account) (USER_DATA)
     * @param {QueryUniversalTransferHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<QueryUniversalTransferHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Query-Universal-Transfer-History Binance API Documentation}
     */
    public async queryUniversalTransferHistory(
        requestParameters: QueryUniversalTransferHistoryRequest = {}
    ): Promise<RestApiResponse<QueryUniversalTransferHistoryResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.queryUniversalTransferHistory(
                requestParameters?.fromEmail,
                requestParameters?.toEmail,
                requestParameters?.clientTranId,
                requestParameters?.startTime,
                requestParameters?.endTime,
                requestParameters?.page,
                requestParameters?.limit,
                requestParameters?.recvWindow
            );
        return sendRequest<QueryUniversalTransferHistoryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Sub-account Futures Asset Transfer
     *
     *
     * Master account can transfer max 2000 times a minute
     * There must be sufficient margin balance in futures wallet to execute transferring.
     *
     * Weight: 1
     *
     * @summary Sub-account Futures Asset Transfer (For Master Account) (USER_DATA)
     * @param {SubAccountFuturesAssetTransferRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<SubAccountFuturesAssetTransferResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Sub-account-Futures-Asset-Transfer Binance API Documentation}
     */
    public async subAccountFuturesAssetTransfer(
        requestParameters: SubAccountFuturesAssetTransferRequest
    ): Promise<RestApiResponse<SubAccountFuturesAssetTransferResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.subAccountFuturesAssetTransfer(
                requestParameters?.fromEmail,
                requestParameters?.toEmail,
                requestParameters?.futuresType,
                requestParameters?.asset,
                requestParameters?.amount,
                requestParameters?.recvWindow
            );
        return sendRequest<SubAccountFuturesAssetTransferResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Sub-account Transfer History
     *
     * If type is not sent, the records of type 2: transfer out will be returned by default.
     * If startTime and endTime are not sent, the recent 30-day data will be returned.
     *
     * Weight: 1
     *
     * @summary Sub-account Transfer History (For Sub-account) (USER_DATA)
     * @param {SubAccountTransferHistoryRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<SubAccountTransferHistoryResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Sub-account-Transfer-History Binance API Documentation}
     */
    public async subAccountTransferHistory(
        requestParameters: SubAccountTransferHistoryRequest = {}
    ): Promise<RestApiResponse<SubAccountTransferHistoryResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.subAccountTransferHistory(
            requestParameters?.asset,
            requestParameters?.type,
            requestParameters?.startTime,
            requestParameters?.endTime,
            requestParameters?.limit,
            requestParameters?.returnFailHistory,
            requestParameters?.recvWindow
        );
        return sendRequest<SubAccountTransferHistoryResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Transfer to Master
     *
     * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
     *
     * Weight: 1
     *
     * @summary Transfer to Master (For Sub-account) (USER_DATA)
     * @param {TransferToMasterRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<TransferToMasterResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Transfer-to-Master Binance API Documentation}
     */
    public async transferToMaster(
        requestParameters: TransferToMasterRequest
    ): Promise<RestApiResponse<TransferToMasterResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.transferToMaster(
            requestParameters?.asset,
            requestParameters?.amount,
            requestParameters?.recvWindow
        );
        return sendRequest<TransferToMasterResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Transfer to Sub-account of Same Master
     *
     * You need to open Enable Spot & Margin Trading permission for the API Key which requests this endpoint.
     *
     * Weight: 1
     *
     * @summary Transfer to Sub-account of Same Master (For Sub-account) (USER_DATA)
     * @param {TransferToSubAccountOfSameMasterRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<TransferToSubAccountOfSameMasterResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Transfer-to-Sub-account-of-Same-Master Binance API Documentation}
     */
    public async transferToSubAccountOfSameMaster(
        requestParameters: TransferToSubAccountOfSameMasterRequest
    ): Promise<RestApiResponse<TransferToSubAccountOfSameMasterResponse>> {
        const localVarAxiosArgs =
            await this.localVarAxiosParamCreator.transferToSubAccountOfSameMaster(
                requestParameters?.toEmail,
                requestParameters?.asset,
                requestParameters?.amount,
                requestParameters?.recvWindow
            );
        return sendRequest<TransferToSubAccountOfSameMasterResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Universal Transfer
     *
     * You need to enable "internal transfer" option for the api key which requests this endpoint.
     * Transfer from master account by default if fromEmail is not sent.
     * Transfer to master account by default if toEmail is not sent.
     * At least either fromEmail or toEmail need to be sent when the fromAccountType and the toAccountType are the same.
     * Supported transfer scenarios:
     * `SPOT` transfer to `SPOT`, `USDT_FUTURE`, `COIN_FUTURE` (regardless of master or sub)
     * `SPOT`, `USDT_FUTURE`, `COIN_FUTURE` transfer to `SPOT`  (regardless of master or sub)
     * Master account `SPOT` transfer to sub-account `MARGIN(Cross)`, `ISOLATED_MARGIN`
     * Sub-account `MARGIN(Cross)`, `ISOLATED_MARGIN` transfer to master account `SPOT`
     * Sub-account `MARGIN(Cross)` transfer to Sub-account `MARGIN(Cross)`
     * `ALPHA` to `ALPHA`  (regardless of master or sub)
     *
     * Weight: 360
     *
     * @summary Universal Transfer (For Master Account) (USER_DATA)
     * @param {UniversalTransferRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<UniversalTransferResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof AssetManagementApi
     * @see {@link https://developers.binance.com/docs/sub_account/asset-management/Universal-Transfer Binance API Documentation}
     */
    public async universalTransfer(
        requestParameters: UniversalTransferRequest
    ): Promise<RestApiResponse<UniversalTransferResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.universalTransfer(
            requestParameters?.fromAccountType,
            requestParameters?.toAccountType,
            requestParameters?.asset,
            requestParameters?.amount,
            requestParameters?.fromEmail,
            requestParameters?.toEmail,
            requestParameters?.clientTranId,
            requestParameters?.symbol,
            requestParameters?.recvWindow
        );
        return sendRequest<UniversalTransferResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }
}
